import { computed } from 'mobx';

export default class SupplierModel {
  id;
  store;

  constructor(store, supplier) {
    this.store = store;
    this.id = +supplier.id;
    this.name = supplier.name;
    this.address = supplier.address;
    this.contact_person = supplier.contact_person;
    this.phone_number = supplier.phone_number;
    this.email = supplier.email;
  }

  @computed get asJson() {
    return {
      id: +this.id,
      name: this.name,
      address: this.address,
      contact_person: this.contact_person,
      phone_number: this.phone_number,
      email: this.email,
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.name = json.name;
    this.address = json.address;
    this.contact_person = json.contact_person;
    this.phone_number = json.phone_number;
    this.email = json.email;
  }
}



// WEBPACK FOOTER //
// ./src/models/Inventory/InventorySupplierModel.js